import React from 'react';
import '../component-styles/Loading.css'; // Import your CSS file for styling

const LoadingPage = () => {
  return (
    <div class="loader">
      <div class="justify-content-center jimu-primary-loading"></div>
    </div>
  );
};

export default LoadingPage;
